import React, { useEffect, useState } from 'react'
// import Slider from "react-slick";
import { useNavigate } from 'react-router-dom';
// import { useTranslation } from "react-i18next";
import { _Api } from '../../common/api';
// import Cursor from 'quill/blots/cursor';
export default function JwelleNewArrival({title}) {
    const navigate = useNavigate();
    // const base_assets = process.env.REACT_APP_BASE_ASSETS_URL

    // const { t } = useTranslation();
    const [sliderlist, setSliderlist] = useState()
   
   
    const sliderdata = async () => {
        try {
            let postdata = {
                type: "collection"
            }
            let res = await _Api(postdata, `product/new-arrivals`)
            if (res?.statusCode === 200) {
               
                setSliderlist(res?.data)
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }


    useEffect(() => {
        sliderdata()
    }, [])

  return (
    <>

        {sliderlist?.length ? sliderlist.map((product, key) =>{
            if(key>4){return null}
            return (
<div key={key} className="ecommerce-homepage-jwelle_container-inner-block" style={{cursor:'pointer'}} onClick={()=> { navigate(`product/${product?.Slug ? product?.Slug : ''}`)}}>
    {product.images.map((image, index) =>{
                    if(index >0){return null}
                    return (
                        <img key={index} src={image?.original} alt="jewell"/>
                )})}
                                   
                                    <span className="ecommerce-homepage-jwelle_container-inner-block-label">{product.name.toLowerCase()}</span>
                                </div>
        )}) : null}

</>
  )



  
}






